// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles_checkboxWrapper__l-X7y","overlayPanelWrapper":"styles_overlayPanelWrapper__VZC9k"};